import React from 'react';
import { AdvancedImage, lazyload, placeholder } from '@cloudinary/react';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';
import { CloudinaryImageType } from '@appTypes/CloudinaryImageType';
import { IllustrationBox } from './styles';

export const HeroIllustrationImage = ({ image }: { image: CloudinaryImageType }) => {
  const publicId = image?.public_id || image?.publicId;
  const { getResponsiveImage } = useCloudinary();
  const mainImage = getResponsiveImage(publicId);
  return (
    <IllustrationBox>
      <AdvancedImage
        cldImg={mainImage}
        plugins={[lazyload({ threshold: 0.25 }), placeholder({ mode: 'blur' })]}
        alt={image.alt || image.altText || image.caption}
      />
    </IllustrationBox>
  );
};
